import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/darkmode/DarkModeBtn.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/vercel/path0/components/darkmode/Providers.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next-view-transitions@0.3.5_next@15.0.5_react-dom@18.3.1_react@18.3.1__react@18.3.1__react-do_6xjgor7nwaoefhcvrlkqzldtua/node_modules/next-view-transitions/dist/index.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/styles/globals.css");
